<template>
  <div class="ui padded centered grid">

    <nav-back-office-top></nav-back-office-top>

    <div class="sixteen wide column">
      <h2 class="ui big header">FAQs</h2>
      <div class="ui divider"></div>


      <div class="ui accordion">
        <div class="title">
          <div class="ui header">
            <i class="dropdown icon"></i>
            How to add action and action plans?
          </div>
        </div>
        <div class="large content">
          <p><b>Actions</b> are things that you want the patient to <b>do</b> either daily or on a once-off basis.</p>

          <p><b>An action plan</b> is a group of actions. Actions can belong to more than one action plans.</p>

          <p><b><i>Video Link: How to add action and action plans?</i></b> </p>
          <div class="ui embed" data-source="youtube" data-id="G_4Jau-Ffls"></div>

        </div>

        <div class="title">
          <div class="ui header">
            <i class="dropdown icon"></i>
            How to add lesson and lesson plans?
          </div>
        </div>
        <div class="large content">
          <p>Lesson are things that you want the patient to <b>learn about</b> e.g. articles or video links.</p>

          <p><b>A lesson plan</b> is a group of lessons. Lessons can belong to more than one lesson plan.</p>

          <p><b><i>Video Link: How to add lessons and lesson plans?</i></b></p>
          <div class="ui embed" data-source="youtube" data-id="H4Y5eEGzy5o"></div>

        </div>

        <div class="title">
          <div class="ui header">
            <i class="dropdown icon"></i>
            How to add patients?
          </div>
        </div>
        <div class="large content">

          <p>Note: Patients can only be added to the back office if they have an existing Migraine Buddy account.</p>

          <p><b><i>Video Link: How to add patients?</i></b></p>
          <div class="ui embed" data-source="youtube" data-id="hITSJaudUzA"></div>

        </div>

        <div class="title">
          <div class="ui header">
            <i class="dropdown icon"></i>
            How would the Employer Buddy link work?
          </div>
        </div>
        <div class="large content">

          <div class="ui small header">Case A: When the patient DOES NOT HAVE Migraine Budd</div>
          <div class="ui embed" data-source="youtube" data-id="MCv3ZDFEoU8"></div>

          <div class="ui divider"></div>

          <div class="ui small header">Case B: When the patient ALREADY HAS Migraine Budd</div>
          <div class="ui embed" data-source="youtube" data-id="pE2cY-6oJ2k"></div>

        </div>

      </div>

    </div>

  </div>
</template>

<script>
  import NavBackOfficeTop from '../NavBackOfficeTop.vue'
	export default {
    components: {
      NavBackOfficeTop
    },
		data() {
			return {}
		},
		computed: {},
		methods: {},
		mounted() {
      $('.ui.accordion').accordion({exclusive: false}).accordion();

      $('.ui.embed').embed();

    }
	}
</script>

<style scoped>
  .large {
    font-size: 1.4em;
  }

</style>



// WEBPACK FOOTER //
// src/components/help/PageGetStarted.vue